<template>
    <div class="option-values-wrapper">

        <div class="row pb-0" v-if="existingOptionValues || isFiltered">

            <div class="col-md-12">
                <table class="option-table">
                    <tr class="option-row-wrapper option-row">
                        <th class="option-column-header order-column">Order</th>
                        <th class="option-column-header label-column">{{ columnHeader }} Label</th>
                        <th class="option-column-header value-column">{{ columnHeader }} Value</th>
                        <th class="option-column-header delete-column">&nbsp;</th>
                    </tr>

                    <option-row v-for="row in masterOptionValues.data" :key="row.id"
                                :version="versionSelected"
                                :row-data="row"
                                :option-id="optionId"
                                @lock-form-toggle="handleLockForm"
                                @value-list-change="handleValueListChange">
                    </option-row>

                </table>

                <div class="load-indicator" v-show="showLoading">
                    <span class="fa fa-cog fa-spin fa-1x"></span>
                </div>

                <div class="result-tools">
                    <search placeholder="Search/Filter"></search>

                    <pagination
                        class="pagination-padding"
                        v-show="showPagination"
                        :pagination="paginationData"
                        @paginate="handlePagination">
                    </pagination>
                </div>
            </div>
        </div>

        <div class="row pb-0" v-if="versionSelected != 0 && !existingOptionValues">

            <div class="col-md-12">
                Note: You can only create new option values when master version is selected. Please use dropdown above to select Master version.
            </div>
        </div>

        <div class="row pb-0" v-if="versionSelected == 0">

            <div class="col-md-12">
                <div class="option-column-header label-column pb-3">Add New Value</div>
                <option-row :row-data="{}"
                            :add-new-value="true"
                            :option-id="optionId"
                            :version="versionSelected"
                            @value-list-change="handleValueListChange"
                            @lock-form-toggle="handleLockForm"
                            >
                </option-row>
            </div>
        </div>

    </div>
</template>

<script>


import Pagination from '../generic/tables/pagination.vue';
import Search from '../generic/tables/search.vue';
import VersionSelector from '../generic/version-selector.vue';
import OptionRow from './option-row.vue';

export default {
    name: 'values',
    components: {
        'version-selector': VersionSelector,
        'option-row': OptionRow,
        'pagination': Pagination,
        'search': Search,
    },
    props: {
        columnHeader: String,
        referenceColumnHeader: String,
        versionSelected: String,
        optionId: String,
        versionInfo: Object,
        masterOptionValues: Object,
        showLoading: Boolean,
        isFiltered: Boolean,
    },
    computed: {
        existingOptionValues() {
            if (this.masterOptionValues != undefined && this.masterOptionValues.hasOwnProperty('data')) {
                return (this.masterOptionValues.data.length > 0);
            }
            return false;
        },
        showPagination() {
            if (this.masterOptionValues.hasOwnProperty('meta')) {
                return this.masterOptionValues.meta.last_page > 1;
            }
            return true;
        },
        paginationData() {
            if (this.masterOptionValues != undefined && this.masterOptionValues.hasOwnProperty('meta')) {
                return this.masterOptionValues.meta;
            }
            return {};
        },
    },
    data() {
        return {
            showNewValue: false,
        }
    },
    methods: {
        handleLockForm(value) {
            //pass this up to the parent
            this.$emit('lock-form-toggle', value);
        },
        handlePagination() {
            //nothing to do?
        },
        getRelatedVersionValueForMasterValue(masterValueItem) {
            if (this.versionSelected == '0') {
                masterValueItem.masterOptionValueId = masterValueItem.optionValueId;
                return masterValueItem;
            }

            if (masterValueItem.version != null) {
                return masterValueItem.version;
            }

            return {};
        },
        addNewValue() {
            this.showNewValue = true;
        },
        createNewValue() {
            //send a message into the option row telling it to save the option value
        },
        cancelNewValue() {
            this.showNewValue = false;
        },
        handleValueListChange(navigateToLastPageOnComplete) {
            if (navigateToLastPageOnComplete == null || navigateToLastPageOnComplete == undefined) {
                navigateToLastPageOnComplete = false;
            }
            this.showNewValue = false;
            this.$emit('refresh-options', navigateToLastPageOnComplete)
        }
    }
};
</script>

<style>
.option-table {
    width: 100%;
}
.option-row  {
    display: flex;
}
.order-column {
    max-width: 60px;
    width: 100%;
}
.delete-column {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 56px;
}
.option-column-header {
    text-transform: capitalize;
}
.result-tools {
    margin: 3px 2px;
    display: flex;
    justify-content: space-between;
}
.pagination-padding {
    padding-right: 60px;
}
.item-wrapper {
    position: relative;
}

</style>